'use es6';

import styled from 'styled-components';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { INPUT_STYLES } from './constants';
const Checkbox = styled(UICheckbox).withConfig({
  displayName: "Checkbox",
  componentId: "sc-10vjtbk-0"
})(["", ""], INPUT_STYLES);
export default Checkbox;